import { useEffect, Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";

const Services = lazy(() => import("@/pages/Services"));
const PressureWashing = lazy(() => import("@/pages/PressureWashing"));
const HandymanServices = lazy(() => import("@/pages/HandymanServices"));
const PaintingServices = lazy(() => import("@/pages/PaintingServices"));
const FlooringInstallation = lazy(() => import("@/pages/FlooringInstallation"));
const PropertyMaintenance = lazy(() => import("@/pages/PropertyMaintenance"));
const Estimate = lazy(() => import("@/pages/Estimate"));
const Schedule = lazy(() => import("@/pages/Schedule"));
const About = lazy(() => import("@/pages/About"));
const ServiceAreas = lazy(() => import("@/pages/ServiceAreas"));
const Reviews = lazy(() => import("@/pages/Reviews"));
const Faq = lazy(() => import("@/pages/Faq"));
const Contact = lazy(() => import("@/pages/Contact"));
const AdminLogin = lazy(() => import("@/pages/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("@/pages/admin/AdminDashboard"));
const PrivacyPage = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.PrivacyPage })));
const TermsPage = lazy(() => import("@/pages/Legal").then((m) => ({ default: m.TermsPage })));

function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.11, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-[60vh]" />}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/pressure-washing" element={<PressureWashing />} />
              <Route path="/handyman-services" element={<HandymanServices />} />
              <Route path="/painting-services" element={<PaintingServices />} />
              <Route path="/flooring-installation" element={<FlooringInstallation />} />
              <Route path="/property-maintenance" element={<PropertyMaintenance />} />
              <Route path="/estimate" element={<Estimate />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/about" element={<About />} />
              <Route path="/service-areas" element={<ServiceAreas />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="*" element={<Home />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </Suspense>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
